var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "21",
        viewBox: "0 0 21 21",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M10.75 0.84082C5.23 0.84082 0.75 5.32082 0.75 10.8408C0.75 16.3608 5.23 20.8408 10.75 20.8408C16.27 20.8408 20.75 16.3608 20.75 10.8408C20.75 5.32082 16.27 0.84082 10.75 0.84082ZM10.75 3.84082C12.41 3.84082 13.75 5.18082 13.75 6.84082C13.75 8.50082 12.41 9.84082 10.75 9.84082C9.09 9.84082 7.75 8.50082 7.75 6.84082C7.75 5.18082 9.09 3.84082 10.75 3.84082ZM10.75 18.0408C8.25 18.0408 6.04 16.7608 4.75 14.8208C4.78 12.8308 8.75 11.7408 10.75 11.7408C12.74 11.7408 16.72 12.8308 16.75 14.8208C15.46 16.7608 13.25 18.0408 10.75 18.0408Z",
          fill: "current",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }